import { Component, OnInit, Input, Output } from "@angular/core";
import { EventEmitter } from "@angular/core";
import { GlobalService } from "../../../global.service";
import { Service } from "../../../services";
import { LoadingScreenService } from "../../../services/loading-screen/loading-screen.service";
import { ChangeplanTermsComponent } from "../../../changeplan/components/changeplan-terms/changeplan-terms.component";
import { ChangeplanTermsFixedComponent } from "../../../changeplan/components/changeplan-terms-fixed/changeplan-terms-fixed.component";
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from "@angular/material";
import { MessageService } from "src/app/message.service";

@Component({
  selector: "app-selected-plan",
  templateUrl: "./selected-plan.component.html",
  styleUrls: ["./selected-plan.component.sass"],
})
export class SelectedPlanComponent implements OnInit {
  @Input() index;

  public currentList;
  public postpago;
  public prepago;
  public totalAccountList;
  public type;
  public token: string = sessionStorage.getItem("token");
  public planActual = "";
  public rectaActual;
  public accountSubType;
  public accountType;
  public amount;
  public ivuState;
  public tax;
  public totalPagar;
  public screenView;
  public cycleEndDate;
  public activatedTerms = false;
  public contractOption = 0;
  public activationOption = 0;
  public contractMonthsTxt = "";
  public contractMonths = 0;
  public message = "";
  public orignomo = 0;

  public paymentData;
  @Output() updatescreenview = new EventEmitter<any>();
  @Output() updatepayment = new EventEmitter<any>();
  @Output() updatepaymentview = new EventEmitter<any>();
  @Output() updateNroOrder = new EventEmitter<boolean>();
  @Output() checkContract = new EventEmitter();
  @Output() updateNumberOrder = new EventEmitter<String>();
  @Output() updateinitializeData = new EventEmitter();
  @Input() currentPlan;
  @Input() actualPrice;
  @Input() planToChange;
  @Input() descriptions;
  @Input() pricePlan;
  @Input() currentPlanId;
  @Input() nextDate;
  @Input() textoMovil;
  @Input() actualType;
  @Input() currentSoc;
  @Input() nextSoc;
  @Input() subscriberNumber;
  @Input() telefoniaFijo;
  @Input() commitmentOriginalMonths;
  @Input() numberOrder;
  @Input() selectBan;

  constructor(
    private global: GlobalService,
    private services: Service,
    public dialog: MatDialog,
    private loadingScreenService: LoadingScreenService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.cycleEndDate = JSON.parse(
      atob(sessionStorage.getItem("getAccountDetails"))
    ).AccounInfo.cycleEndDateField;
    this.nextDate = this.currentDate(this.cycleEndDate);
    this.currentDate(this.nextDate);
  }

  currentDate(fecha) {
    if (fecha) {
      fecha = new Date(fecha);
    } else {
      fecha = new Date();
    }
    var mes = fecha.getMonth();
    var diaMes = fecha.getDate();
    var diaSemana = fecha.getDay();
    var anio = fecha.getFullYear();
    var dias = new Array(
      "Domingo",
      "Lunes",
      "Martes",
      "Miercoles",
      "Jueves",
      "Viernes",
      "Sábado"
    );
    var meses = new Array(
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    );
    return (
      dias[diaSemana] + ", " + diaMes + " de " + meses[mes] + " de " + anio
    );
  }
  changeCheck(type, id) {
    if (this.global.validateSession() === true) {
      var radioActual = document.getElementById(
        "radio-" + type + id
      ) as HTMLInputElement;
      var contentActual = document.getElementById(
        "content-" + type + id
      ) as HTMLInputElement;
      var objChecked1;
      var objChecked2;
      var objContent1;
      var objContent2;
      if (type == "contrato") {
        objChecked1 = document.getElementById(
          "radio-contrato1"
        ) as HTMLInputElement;
        objChecked2 = document.getElementById(
          "radio-contrato2"
        ) as HTMLInputElement;
        objContent1 = document.getElementById(
          "content-contrato1"
        ) as HTMLInputElement;
        objContent2 = document.getElementById(
          "content-contrato2"
        ) as HTMLInputElement;
        if (this.commitmentOriginalMonths == 24) {
          radioActual.checked = true;
          contentActual.className =
            "optchoice hauto on roboto-r text-left caja2";
          this.contractOption = 24;
        } else {
          if (objChecked1.checked === false && objChecked2.checked === true) {
            if (radioActual.id === "radio-contrato1") {
              this.contractOption = 12;
              objChecked1.checked = true;
              objContent1.className = "optchoice hauto on roboto-r text-left";
              objChecked2.checked = false;
              objContent2.className = "optchoice hauto roboto-r text-left";
            } else {
              this.contractOption = 24;
              objChecked1.checked = false;
              objContent1.className = "optchoice hauto roboto-r text-left";
              objChecked2.checked = true;
              objContent2.className = "optchoice hauto on roboto-r text-left";
            }
          } else {
            if (id === 1) {
              this.contractOption = 12;
              objChecked1.checked = true;
              objContent1.className = "optchoice on hauto roboto-r text-left";
              objChecked2.checked = false;
              objContent2.className = "optchoice hauto  roboto-r text-left";
            } else {
              this.contractOption = 24;
              objChecked1.checked = false;
              objContent1.className = "optchoice  hauto roboto-r text-left";
              objChecked2.checked = true;
              objContent2.className = "optchoice hauto on  roboto-r text-left";
            }
          }
        }
      } else {
        const objChecked1 = document.getElementById(
          "radio-activacion1"
        ) as HTMLInputElement;
        const objChecked2 = document.getElementById(
          "radio-activacion2"
        ) as HTMLInputElement;
        const objContent1 = document.getElementById(
          "content-activacion1"
        ) as HTMLInputElement;
        const objContent2 = document.getElementById(
          "content-activacion2"
        ) as HTMLInputElement;
        if (objChecked1.checked === false && objChecked2.checked === true) {
          if (radioActual.id === "radio-activacion1") {
            this.activationOption = 1;
            objChecked1.checked = true;
            objContent1.className = "optchoice hauto on roboto-r text-left";
            objChecked2.checked = false;
            objContent2.className = "optchoice hauto roboto-r text-left";
          } else {
            this.activationOption = 2;
            objChecked1.checked = false;
            objContent1.className = "optchoice hauto roboto-r text-left";
            objChecked2.checked = true;
            objContent2.className = "optchoice hauto on roboto-r text-left";
          }
        } else {
          if (id === 2) {
            this.activationOption = 2;
            objChecked1.checked = false;
            objContent1.className = "optchoice  hauto roboto-r text-left";
            objChecked2.checked = true;
            objContent2.className = "optchoice hauto on roboto-r text-left";
          } else {
            this.activationOption = 1;
            objChecked1.checked = true;
            objContent1.className = "optchoice on hauto roboto-r text-left";
            objChecked2.checked = false;
            objContent2.className = "optchoice hauto  roboto-r text-left";
          }
        }
      }
    }
  }
  showterms() {
    if (this.global.validateSession() === true) {
      if (sessionStorage.getItem("session") != null) {
        this.global.validateSession();
      }
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      this.dialog.open(ChangeplanTermsComponent, dialogConfig);
    }
  }
  showtermsFixed() {
    if (this.global.validateSession() === true) {
      if (sessionStorage.getItem("session") != null) {
        this.global.validateSession();
      }
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      this.dialog.open(ChangeplanTermsFixedComponent, dialogConfig);
    }
  }
  backPage() {
    if (this.global.validateSession()) {
      this.updatescreenview.emit(1);
    }
  }
  activateTerms() {
    if (this.global.validateSession() === true) {
      var check = document.getElementById("activatedTerms") as HTMLInputElement;
      this.activatedTerms = check.checked;
    }
  }
  applyChange() {
    if (this.global.validateSession() === true) {
      if (this.activatedTerms === true) {
        if (this.actualType === "G") {
          if (this.activationOption !== 0) {
            if (this.activationOption === 1) {
              this.activarPlanNow();
            } else {
              this.activarPlanNext();
            }
          } else {
            this.global.notif("Debe seleccionar un método de activacion.");
          }
        } else {
          if (this.contractOption !== 0) {
            if (this.contractOption === 12) {
              this.contractMonthsTxt = "12months";
              this.contractMonths = 12;
            } else {
              this.contractMonthsTxt = "24months";
              this.contractMonths = 24;
            }
            this.adaDslPackageChange();
          } else {
            this.global.notif("Debe seleccionar un Termino del Contrato.");
          }
        }
      } else {
        this.global.notif("Debe aceptar los Términos y Condiciones.");
      }
    }
  }
  goToPayment(a) {
    var price = this.actualPrice;
    let datasend = "";
    if (a == 1) {
      datasend =
        '{"data":{"module":"changeplan","params":{"currentSoc":"' +
        this.currentSoc +
        '","nextSoc":"' +
        this.nextSoc +
        '","actualType":"' +
        this.actualType +
        '","subscriberNumber":"' +
        this.subscriberNumber +
        '","service":"1"},"labels":[{"label":"producto","text":"' +
        this.currentPlan +
        '"},{"label":"monto","text":"$' +
        this.actualPrice +
        '"}],"confirmText":"el cambio de plan se ha realizado exitosamente","mount":"' +
        price +
        '","product":"' +
        this.currentPlan +
        '"}}';
    } else if (a == 2) {
      datasend =
        '{"data":{"module":"changeplan","params":{"currentSoc":"' +
        this.currentSoc +
        '","nextSoc":"' +
        this.nextSoc +
        '","actualType":"' +
        this.actualType +
        '","subscriberNumber":"' +
        this.subscriberNumber +
        '", "selectBan": "' +
        this.selectBan +
        '","service":"2"},"labels":[{"label":"producto","text":"' +
        this.currentPlan +
        '"},{"label":"monto","text":"$' +
        this.actualPrice +
        '"}],"confirmText":"el cambio de plan se ha realizado exitosamente","mount":"' +
        price +
        '","product":"' +
        this.currentPlan +
        '"}}';
    } else if (a == 3) {
      datasend =
        '{"data":{"module":"changeplan","params":{"contractMonthsTxt":"' +
        this.contractMonthsTxt +
        '","nextSoc":"' +
        this.nextSoc +
        '","actualType":"' +
        this.actualType +
        '","subscriberNumber":"' +
        this.subscriberNumber +
        '", "selectBan": "' +
        this.selectBan +
        '","service":"3"},"labels":[{"label":"producto","text":"' +
        this.currentPlan +
        '"},{"label":"monto","text":"$' +
        this.actualPrice +
        '"}],"confirmText":"el cambio de plan se ha realizado exitosamente","mount":"' +
        price +
        '","product":"' +
        this.currentPlan +
        '"}}';
    }

    this.paymentData = JSON.parse(datasend);

    this.updatepayment.emit(this.paymentData);
    this.updatepaymentview.emit(1);
  }
  activarPlanNow() {
    this.loadingScreenService.startLoading();
    this.services
      .activarPlanNow(
        this.token,
        this.currentSoc,
        this.nextSoc,
        this.actualType,
        this.subscriberNumber
      )
      .subscribe((data) => {
        if (data.HasError === false) {
          this.updateinitializeData.emit();
          this.updatescreenview.emit(3);
          this.updateNroOrder.emit(false);
        } else {
          this.loadingScreenService.stopLoading();
          this.global.notif(data.ErrorDesc);
          this.messageService.sentMessage("canceled", {
            method: "Error  activando el plan",
          });
        }
      }, error => {
        this.messageService.sentMessage("canceled", {
            method: "Error  activando el plan",
          });
      });
  }
  activarPlanNext() {
    this.loadingScreenService.startLoading();
    this.services
      .activarPlanNext(
        this.token,
        this.currentSoc,
        this.nextSoc,
        this.actualType,
        this.subscriberNumber,
        this.selectBan
      )
      .subscribe((data) => {
        if (data.HasError === false) {
          this.updateinitializeData.emit();
          this.updatescreenview.emit(3);
          this.updateNroOrder.emit(false);
        } else {
          this.loadingScreenService.stopLoading();
          this.global.notif(data.ErrorDesc);
          this.messageService.sentMessage("canceled", {
            method: "Error  activando el plan",
          });
        }
      }, error => {
        this.messageService.sentMessage("canceled", {
            method: "Error  activando el plan",
          });
      });
  }
  adaDslPackageChange() {
    this.loadingScreenService.startLoading();
    this.services
      .adaDslPackageChange(
        this.token,
        this.contractMonthsTxt,
        "Y",
        this.subscriberNumber,
        this.nextSoc,
        this.selectBan,
        this.actualPrice,
        this.actualType
      )
      .subscribe((data) => {
        this.loadingScreenService.stopLoading();
        if (data.HasError === false) {
          this.message = data.ErrorDesc;
          this.updatescreenview.emit(3);
          if (data.orderNumber === "000000") {
            this.updateNroOrder.emit(false);
          }
          if (data.responseCode === "003") {
            this.updateNumberOrder.emit(data.orderNumber);
            this.updateNroOrder.emit(true);
          }
          if (data.responseCode === "004") {
            this.updateNumberOrder.emit(data.orderNumber);
            this.updateNroOrder.emit(true);
          }
        } else {
          this.loadingScreenService.stopLoading();
          this.global.notif(data.ErrorDesc);
          this.messageService.sentMessage("canceled", {
            method: "Error  activando el paquete",
          });
        }
      }, error => {
        this.messageService.sentMessage("canceled", {
            method: "Error  activando el paquete",
          });
      });
  }
}
